import { BaseIllustration, BaseIllustrationProps } from '../BaseIllustration';

export type ToolsIllustrationProps = Omit<BaseIllustrationProps, 'children'>;

export const ToolsIllustration = ({ ...props }: ToolsIllustrationProps) => (
  <BaseIllustration width="64" height="64" viewBox="0 0 64 64" {...props}>
    <g strokeWidth={2} strokeLinecap="square" strokeLinejoin="miter" strokeMiterlimit="10" fill="none">
      <path d="M44.438,34.531,56.352,45a8.034,8.034,0,0,1,.575,11.347c-.091.1-.184.2-.28.3h0a8.035,8.035,0,0,1-11.363,0c-.1-.1-.189-.2-.28-.3L34.8,45.23" />
      <polyline points="30.608 26.608 20 16 20 12 13 5 5 13 12 20 16 20 26.29 30.29" strokeLinecap="butt" />
      <path d="M60.9,23.1,45.1,7.3A11.468,11.468,0,0,0,29,7.3L52.8,31.1Z" />
      <path
        d="M40.163,18.462,5.412,48.089a4,4,0,0,0-.24,5.879l4.86,4.86a4,4,0,0,0,5.879-.24L45.579,23.879"
        strokeLinecap="butt"
      />
    </g>
  </BaseIllustration>
);

ToolsIllustration.displayName = 'ToolsIllustration';
